import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable, { static: false }) table: MatTable<any>;
  @Input() tableData;
  @Input() tableColumnsNames;
  @Output() rowSelected = new EventEmitter<any>();
  public columnNames;
  dataSource = new MatTableDataSource();
  constructor() { }

  ngOnInit(): void {
    if (this.tableData) {
      this.columnNames = Object.keys(this.tableData);
    }
    if (this.tableColumnsNames) {
      this.columnNames = Object.keys(this.tableColumnsNames);
    }
    this.dataSource.data = this.tableData;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  renderTable() {
    console.log('reder rows');
    this.dataSource.data = this.tableData.filter(elem => elem);
    console.log(this.tableData, 'table data')
    this.table.renderRows();
  }

  triggerAction(action, col) {
    console.log(col, 'coll', action)
    this.rowSelected.emit({ data: col, action: action })
  }

}
